import MessageCommon from 'epic-localization/src/client/message/Message';
import {mapStateToProps as mapLocalizationStateToProps} from 'epic-localization/src/client/reducers/localization.reducer';

const reducerName = 'localization';
export default MessageCommon(reducerName);
export const mapStateToProps = mapLocalizationStateToProps(reducerName);
export {getMessage} from 'epic-localization/src/client/message/Message';
